import asset from 'src/xhr/services/asset'

const API = asset()

export async function listHouseAssets(houseSpaceId) {
  try {
    const res = await API.houseAsset.list(houseSpaceId)
    if (res.data.code !== 200) {
      return Promise.reject(new Error(res.data.message))
    }

    return res.data.data.map(o => {
      const { assetTypeBean, assetBeans, isPublic } = o
      delete assetTypeBean.pid
      delete assetTypeBean.createTime
      delete assetTypeBean.modifyTime
      delete assetTypeBean.parentId
      delete assetTypeBean.path
      delete assetTypeBean.hasChildren

      return {
        ...assetTypeBean,
        isPublic,
        children: Array.isArray(assetBeans)
          ? assetBeans.map(item => {
              delete item.pid
              delete item.createTime
              delete item.modifyTime
              delete item.unit
              delete item.principal
              delete item.durableYears
              delete item.costPrice
              delete item.compensatePrice
              return item
            })
          : [],
      }
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

function getBeanName(bean) {
  return bean !== null && bean !== undefined ? bean.name || '' : ''
}

export async function listHouseAssetOptions(typeId) {
  try {
    const res = await API.houseAssetOption.list(typeId)
    if (res.data.code !== 200) {
      return Promise.reject(new Error(res.data.message))
    }

    return res.data.data.map(o => {
      const { name, children } = o

      return {
        label: name,
        value: name,
        children: children.map(item => ({
          ...item,
          label: `${getBeanName(item.brandBean)} ${getBeanName(
            item.modelBean
          )} ${getBeanName(item.sizeBean)}`,
          value: {
            ...item,
            name: name,
            brandName: getBeanName(item.brandBean),
            modelName: getBeanName(item.modelBean),
            sizeName: getBeanName(item.sizeBean),
            count: 1,
            id: item.assetId,
          },
        })),
      }
    })
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/BusinessContractForm/fetch.js